var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInviteIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 12,
    viewBox: "0 0 14 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.006 6.285c.264 0 .492-.129.767-.404L12.9.766c-.24-.188-.65-.287-1.213-.287H2.22c-.522 0-.897.093-1.125.275L6.238 5.88c.276.275.504.404.768.404ZM.42 10.005l4.312-4.294L.455 1.48c-.14.216-.21.568-.21 1.054V9.02c0 .452.058.78.175.985ZM13.586 10c.111-.205.17-.527.17-.979V2.535c0-.48-.07-.832-.205-1.049L9.273 5.711 13.586 10ZM2.312 11.078h9.475c.55 0 .95-.111 1.195-.316L8.588 6.385 8.27 6.7c-.421.404-.82.598-1.265.598-.445 0-.85-.194-1.266-.598l-.316-.31-4.389 4.365c.258.21.686.322 1.278.322Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInviteIcon);
export default __webpack_public_path__ + "static/media/inviteIcon.5b496fc3346248cb48ad426631992745.svg";
export { ForwardRef as ReactComponent };